const dialog = document.getElementById('VentraQuickView');
if (dialog && typeof dialog.showModal === 'function') {
  const content = dialog.querySelector('[data-qv-content]');
  const footer = dialog.querySelector('[data-qv-footer]');
  const closeButton = dialog.querySelector('.vqv-close');
  let opener, savedY = 0, savedStyles, productUrl, request, sequence = 0, adding = false;
  let activeGallery, activeSlides, galleryIndex = 0;
  const reduced = () => matchMedia('(prefers-reduced-motion:reduce)').matches;
  const text = name => dialog.dataset[name];
  const root = () => window.Shopify?.routes?.root || '/';
  document.body.classList.add('vqv-ready');

  function message(value, success = false) {
    const node = footer.querySelector('[data-qv-message]');
    if (!node) return;
    node.textContent = value;
    node.classList.toggle('is-success', success);
    node.hidden = !value;
  }
  function lock() {
    savedY = window.scrollY;
    savedStyles = ['position','top','left','width','padding-right'].map(key => [key,document.body.style.getPropertyValue(key),document.body.style.getPropertyPriority(key)]);
    const gap = window.innerWidth - document.documentElement.clientWidth;
    const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedY}px`;
    document.body.style.left = '0';
    document.body.style.width = '100%';
    if (gap) document.body.style.paddingRight = `${padding + gap}px`;
  }
  function unlock() {
    if (!savedStyles) return;
    for (const [key,value,priority] of savedStyles) {
      if (value) document.body.style.setProperty(key,value,priority);
      else document.body.style.removeProperty(key);
    }
    savedStyles = null;
    window.scrollTo({top:savedY,behavior:'instant'});
    if (opener?.isConnected) opener.focus({preventScroll:true});
  }
  function state(value, failed = false) {
    content.replaceChildren();
    const panel = document.createElement('div');
    panel.className = 'vqv-state';
    const label = document.createElement('p');
    label.setAttribute('role', failed ? 'alert' : 'status');
    label.textContent = value;
    panel.append(label);
    if (failed) {
      const retry = document.createElement('button');
      retry.type='button'; retry.textContent=text('retry'); retry.addEventListener('click',()=>loadProduct());
      const link=document.createElement('a');link.href=productUrl;link.textContent=text('details');
      panel.append(retry,link);
    }
    content.append(panel);footer.hidden=true;footer.replaceChildren();
  }
  async function fetchProduct(url,signal) {
    const target = new URL(url,location.origin);
    target.searchParams.set('section_id','vfc-quick-view-product');
    const response=await fetch(target,{credentials:'same-origin',signal});
    if(!response.ok) throw new Error('Preview unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const product=doc.querySelector('[data-qv-product]');
    if(!product || !product.querySelector('[data-qv-form]')) throw new Error('Preview unavailable');
    return product;
  }
  function galleryTo(index,instant=false) {
    if(!activeGallery || !activeSlides.length) return;
    galleryIndex=Math.max(0,Math.min(Number.isFinite(index)?index:0,activeSlides.length-1));
    activeGallery.scrollTo({left:activeSlides[galleryIndex].offsetLeft-activeSlides[0].offsetLeft,behavior:instant||reduced()?'instant':'smooth'});
    galleryLabel();
  }
  function galleryLabel() {
    const label=content.querySelector('[data-qv-position]');
    if(label) label.textContent=`${galleryIndex+1} / ${activeSlides.length}`;
    const previous=content.querySelector('[data-qv-prev]'),next=content.querySelector('[data-qv-next]');
    if(previous) previous.disabled=galleryIndex===0;
    if(next) next.disabled=galleryIndex===activeSlides.length-1;
  }
  function connectGallery(imageId) {
    activeGallery=content.querySelector('[data-qv-slides]');
    activeSlides=[...activeGallery.querySelectorAll('.vqv-slide')];
    activeGallery.addEventListener('scroll',()=>{
      if(!activeGallery.clientWidth)return;
      const index=Math.round(activeGallery.scrollLeft/activeGallery.clientWidth);
      if(!Number.isFinite(index))return;
      galleryIndex=Math.max(0,Math.min(activeSlides.length-1,index));
      galleryLabel();
    },{passive:true});
    activeGallery.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'||event.key==='ArrowRight') {event.preventDefault();galleryTo(galleryIndex+(event.key==='ArrowRight'?1:-1));}
    });
    const index=activeSlides.findIndex(slide=>slide.dataset.imageId===imageId);
    if(index>=0) activeSlides[index].querySelector('img')?.setAttribute('loading','eager');
    requestAnimationFrame(()=>galleryTo(index>=0?index:0,true));
  }
  function purchase(product) {
    const block=product.querySelector('[data-qv-purchase]');
    footer.replaceChildren(block);footer.hidden=false;
  }
  async function loadProduct() {
    request?.abort();request=new AbortController();const current=++sequence;
    state(text('loading'));dialog.setAttribute('aria-busy','true');
    try {
      const product=await fetchProduct(productUrl,request.signal);
      if(current!==sequence||!dialog.open) return;
      purchase(product);content.replaceChildren(product);content.scrollTop=0;
      document.dispatchEvent(new CustomEvent('ventra:product-viewed',{detail:{url:productUrl}}));
      dialog.setAttribute('aria-labelledby','VentraQuickProductTitle');connectGallery(product.dataset.imageId);
    } catch(error) {if(error.name!=='AbortError'&&current===sequence&&dialog.open) state(text('loadError'),true);}
    finally {if(current===sequence)dialog.removeAttribute('aria-busy');}
  }
  async function selectVariant(select) {
    request?.abort();request=new AbortController();const current=++sequence;
    const values=[...content.querySelectorAll('[data-qv-option]')].map(node=>node.value);
    const url=new URL(productUrl,location.origin);url.searchParams.delete('variant');url.searchParams.set('option_values',values.join(','));
    const position=content.scrollTop, focusId=select?.id, quantity=Number(footer.querySelector('[name="quantity"]')?.value)||1;
    dialog.dataset.busy='true';dialog.setAttribute('aria-busy','true');message(text('updating'));
    footer.querySelectorAll('button,input').forEach(node=>node.disabled=true);
    try {
      const product=await fetchProduct(url,request.signal);
      if(current!==sequence||!dialog.open)return;
      content.querySelector('[data-qv-info]').replaceWith(product.querySelector('[data-qv-info]'));
      content.querySelector('[data-qv-product]').dataset.variant=product.dataset.variant;
      purchase(product);
      const input=footer.querySelector('[name="quantity"]');
      if(input){const min=Number(input.min)||1,max=Number(input.max)||Infinity,step=Number(input.step)||1;input.value=String(Math.min(max,min+Math.max(0,Math.floor((quantity-min)/step))*step));}
      const index=activeSlides.findIndex(slide=>slide.dataset.imageId===product.dataset.imageId);
      if(index>=0){activeSlides[index].querySelector('img')?.setAttribute('loading','eager');galleryTo(index,true);}
      content.scrollTop=position;
      if(focusId) document.getElementById(focusId)?.focus({preventScroll:true});
    } catch(error) {
      if(error.name!=='AbortError'&&current===sequence&&dialog.open){
        message(text('selectError'));
        const retry=document.createElement('button');retry.type='button';retry.className='vqv-retry';retry.textContent=text('retry');retry.addEventListener('click',()=>selectVariant(select));footer.querySelector('[data-qv-message]').append(' ',retry);
      }
    } finally {if(current===sequence){delete dialog.dataset.busy;dialog.removeAttribute('aria-busy');}}
  }
  async function refreshCart() {
    try {
      const response=await fetch(root()+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)return;
      const cart=await response.json();
      document.querySelectorAll('[data-vfm-cart-count]').forEach(node=>node.textContent=String(cart.item_count));
      document.dispatchEvent(new CustomEvent('ventra:cart-updated',{detail:{cart}}));
    } catch {}
  }
  async function add(form) {
    const button=footer.querySelector('[data-qv-add]');
    if(adding||dialog.dataset.busy||!button||button.disabled||!form.reportValidity()) return;
    const body=new FormData(form),variant=body.get('id');
    if(!variant)return;
    const drawer=document.querySelector('cart-drawer');
    if(!drawer || typeof drawer.renderContents!=='function'){message('Your bag is still loading. Please try again in a moment.');return;}
    body.set('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));body.set('sections_url',location.pathname);
    drawer.setActiveElement(opener);
    adding=true;const current=sequence, original=button.textContent;
    button.disabled=true;button.textContent=text('adding');message('');
    content.querySelectorAll('select').forEach(node=>node.disabled=true);
    footer.querySelectorAll('.vqv-quantity button,.vqv-quantity input').forEach(node=>node.disabled=true);
    let confirmed=false;
    try {
      const response=await fetch(root()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body});
      const result=await response.json();
      if(!response.ok||result.status) {
        if(current===sequence&&dialog.open){message((typeof result.description==='string'?result.description+' ':'')+text('cartError'));footer.querySelector('[data-qv-success]').hidden=false;}
      } else {
        confirmed=true;
        if(current===sequence&&dialog.open){dialog.close();}
        if(drawer.classList.contains('is-empty'))drawer.classList.remove('is-empty');
        if(!result.sections?.['cart-drawer']){const rendered=await fetch(root()+'?sections=cart-drawer,cart-icon-bubble',{credentials:'same-origin'});result.sections=await rendered.json();}
        drawer.renderContents(result);
      }
      await refreshCart();
    } catch {
      if(current===sequence&&dialog.open){message(text('cartError'));footer.querySelector('[data-qv-success]').hidden=false;}
      await refreshCart();
    } finally {
      adding=false;
      if(current===sequence&&dialog.open){
        button.textContent=original;button.disabled=!confirmed;
        content.querySelectorAll('select').forEach(node=>node.disabled=false);
        footer.querySelectorAll('.vqv-quantity button,.vqv-quantity input').forEach(node=>node.disabled=false);
      }
    }
  }
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-quick-view]');
    if(!trigger||event.defaultPrevented)return;
    const url=new URL(trigger.dataset.quickView,location.origin);if(url.origin!==location.origin)return;
    event.preventDefault();opener=trigger;productUrl=url.href;
    if(!dialog.open){lock();dialog.setAttribute('aria-labelledby','VentraQuickViewHeading');dialog.showModal();closeButton.focus({preventScroll:true});}
    loadProduct();
  });
  dialog.addEventListener('click',event=>{
    if(event.target.closest('[data-qv-close]')){dialog.close();return;}
    if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();return;}
    if(event.target.closest('[data-qv-prev]'))galleryTo(galleryIndex-1);
    if(event.target.closest('[data-qv-next]'))galleryTo(galleryIndex+1);
    const quantityButton=event.target.closest('[data-qv-quantity]');
    if(quantityButton){const input=footer.querySelector('[name="quantity"]');if(!input)return;const min=Number(input.min)||1,max=Number(input.max)||Infinity,step=Number(input.step)||1;input.value=String(Math.max(min,Math.min(max,(Number(input.value)||min)+Number(quantityButton.dataset.qvQuantity)*step)));}
  });
  dialog.addEventListener('change',event=>{if(event.target.matches('[data-qv-option]'))selectVariant(event.target);});
  dialog.addEventListener('submit',event=>{if(event.target.matches('[data-qv-form]')){event.preventDefault();add(event.target);}});
  dialog.addEventListener('close',()=>{request?.abort();sequence++;delete dialog.dataset.busy;dialog.removeAttribute('aria-busy');unlock();});
  window.addEventListener('pagehide',()=>{if(dialog.open)dialog.close();});
  document.addEventListener('shopify:section:load',()=>document.body.classList.add('vqv-ready'));
}
